/*
 * @Descripttion: toast提示框
 * @version: 1.0
 * @Author: zhanmei
 * @Date: 2020-07-31 15:16:47
 * @LastEditors: zhanmei
 * @LastEditTime: 2020-08-18 14:56:32
 */


var $ = require('jQuery');
var Component = require('../Component');
var template = require('../../template/toast.html');

var Toast = function (options) {
    (function (self) {
        var defaults = {
            template: template
        };
        $.extend(defaults, options);
        Component.call(self, defaults);
    })(this);
};
Toast.prototype = Object.create(Component.prototype);
/**
 * @msg: toast显示
 * @param {Object} 输入参数
 * {
      content: "收藏成功",  // 必填
      interval:3000,
      type:'new',
      iconStatus:'success/fail'
    }
 * @return null
 */
Toast.prototype.show = function (opt) {
    var self = this;
    var text = opt.content;
    if (!text) {
        return;
    }
    
    if (opt.type && opt.type == 'new') {
        this._element.addClass('im-toast-new');
        var $toastIcon = this._element.find('.im-toast-icon');
        $toastIcon.addClass('show');
        if($toastIcon.hasClass('fail')){
            $toastIcon.removeClass('fail')
        }
    }else{
        this._element.removeClass('im-toast-new');
        var $toastIcon = this._element.find('.im-toast-icon');
        $toastIcon && $toastIcon.removeClass('show');
    }
    if (opt.iconStatus && opt.iconStatus == 'fail') {
        this._element.find('.im-toast-icon').addClass('fail');
    }
    this._element.find('.im-toast-content').text(text);
    Component.prototype.show.call(this);
    var interval = opt.interval ? opt.interval : 2000;
    var toastTimer = setTimeout(function () {
        self.hide();
        clearTimeout(toastTimer);
    }, interval);
};
Toast.prototype.hide = function () {
    Component.prototype.hide.call(this);
};
/**
 * @msg: toast隐藏
 * @param null
 * @return null
 */
module.exports = Toast;
